import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "container-fluid mt-3" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "fab fa-mailchimp me-3 fa-3x" }, null, -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = {
  key: 1,
  style: {"overflow":"hidden"}
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-bookmark me-4 fa-3x fa-rotate-270" }, null, -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = ["value"]
const _hoisted_9 = { key: 0 }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", { class: "mb-2" }, [
  /*#__PURE__*/_createTextVNode(" We love Klaviyo and think it would be even better if it could be used with Loupey. "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Click here if you'd like to see that too: ")
], -1)
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = { key: 1 }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("p", { class: "mb-2" }, [
  /*#__PURE__*/_createTextVNode(" Is there another platform that you'd love to be able to feed into Loupey? "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Tell us about it here: ")
], -1)
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = { key: 2 }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("p", { class: "mb-2" }, "Completing mailchimp authentication", -1)
const _hoisted_17 = { class: "position-relative" }
const _hoisted_18 = { key: 3 }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "mb-4 d-flex align-items-center" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-check-circle me-3 fa-2x text-success" }),
  /*#__PURE__*/_createElementVNode("div", null, "Your Mailchimp account is connected.")
], -1)
const _hoisted_20 = { class: "mb-3" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("label", {
  for: "accountNameInput",
  class: "form-label"
}, "Mailchimp Acount", -1)
const _hoisted_22 = { class: "input-group" }
const _hoisted_23 = ["value"]
const _hoisted_24 = {
  class: "input-group-text",
  id: "accountIdAddOn"
}
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "form-text" }, "It doesn't matter if you change this name property in Mailchimp. We don't use it to conenct.", -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("label", {
  for: "basic-url",
  class: "form-label"
}, "Your Api endpoint:", -1)
const _hoisted_27 = { class: "input-group mb-4" }
const _hoisted_28 = ["value"]
const _hoisted_29 = /*#__PURE__*/_createElementVNode("p", { class: "mb-2" }, "Re-authorise your account if requested to by Loupey Support.", -1)
const _hoisted_30 = ["href"]
const _hoisted_31 = /*#__PURE__*/_createElementVNode("i", { class: "fal fa-key me-2" }, null, -1)
const _hoisted_32 = /*#__PURE__*/_createTextVNode("Re-authorise ")
const _hoisted_33 = [
  _hoisted_31,
  _hoisted_32
]
const _hoisted_34 = { key: 4 }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("p", { class: "mb-2" }, "In order for Loupey to read the data in your mailchimp account, you need to authorise access.", -1)
const _hoisted_36 = ["href"]
const _hoisted_37 = /*#__PURE__*/_createElementVNode("i", { class: "fal fa-key me-2" }, null, -1)
const _hoisted_38 = /*#__PURE__*/_createTextVNode("Authorise ")
const _hoisted_39 = [
  _hoisted_37,
  _hoisted_38
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading = _resolveComponent("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "d-flex align-items-center p-3 mb-4",
      style: _normalizeStyle({ 'background-color': _ctx.platformDetails.backgroundColour, 'border-radius': '0.25rem' })
    }, [
      (_ctx.platformId == 'mailchimp')
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
        : _createCommentVNode("", true),
      (_ctx.platformId == 'klaviyo')
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7))
        : _createCommentVNode("", true),
      _withDirectives(_createElementVNode("select", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.platformId) = $event)),
        id: "integrationSelect",
        class: "form-select form-select-lg",
        style: {"background-color":"#ffffff80","border-color":"#ffffff80","border-width":"2px"}
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.platforms, (platform) => {
          return (_openBlock(), _createElementBlock("option", {
            value: platform.id,
            key: platform.id
          }, _toDisplayString(platform.name), 9, _hoisted_8))
        }), 128))
      ], 512), [
        [_vModelSelect, _ctx.platformId]
      ])
    ], 4),
    (_ctx.platformId == 'klaviyo')
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, _hoisted_11))
      : _createCommentVNode("", true),
    (_ctx.platformId == 'other')
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, _hoisted_14))
      : _createCommentVNode("", true),
    (_ctx.isHandlingCallback)
      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
          _hoisted_16,
          _createElementVNode("div", _hoisted_17, [
            _createVNode(_component_loading, {
              active: !_ctx.isLoaded,
              isErrored: _ctx.isErrored,
              "is-full-page": false,
              errorMessage: _ctx.errorMessage,
              isFullPage: false
            }, null, 8, ["active", "isErrored", "errorMessage"])
          ])
        ]))
      : (_ctx.isAuthorised && _ctx.account != null)
        ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
            _hoisted_19,
            _createElementVNode("div", _hoisted_20, [
              _hoisted_21,
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("input", {
                  disabled: "",
                  value: _ctx.account.integration.mailchimp.accountName,
                  type: "email",
                  class: "form-control",
                  id: "accountNameInput",
                  "aria-describedby": "accountIdAddOn"
                }, null, 8, _hoisted_23),
                _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.account.integration.mailchimp.id), 1)
              ]),
              _hoisted_25
            ]),
            _hoisted_26,
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("input", {
                disabled: "",
                type: "text",
                class: "form-control",
                id: "basic-url",
                value: `https://${_ctx.account.integration.mailchimp.serverPrefix}.api.mailchimp.com/3.0/`
              }, null, 8, _hoisted_28)
            ]),
            _hoisted_29,
            _createElementVNode("a", {
              class: "btn btn-primary",
              target: "_self",
              href: _ctx.platformDetails.authoriseUrl
            }, _hoisted_33, 8, _hoisted_30)
          ]))
        : (_ctx.account != null)
          ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
              _hoisted_35,
              _createElementVNode("a", {
                class: "btn btn-primary",
                target: "_self",
                href: _ctx.platformDetails.authoriseUrl
              }, _hoisted_39, 8, _hoisted_36)
            ]))
          : _createCommentVNode("", true)
  ]))
}